export default "__VITE_ASSET__DjwyuQOK__"